/**
 * Text utilities for safe display of API data.
 * Decodes HTML entities (e.g. &#x27;, &apos;) and normalizes smart quotes
 * that may come from the backend sanitizer or STT/LLM output.
 */
function decodeNumericHtmlEntities(s: string): string {
  return s
    .replace(/&#x([0-9a-fA-F]{1,6});/gi, (_, hex) => {
      const cp = parseInt(hex, 16);
      if (Number.isNaN(cp) || cp < 0 || cp > 0x10ffff) return _;
      try {
        return String.fromCodePoint(cp);
      } catch {
        return _;
      }
    })
    .replace(/&#(\d{1,7});/g, (_, dec) => {
      const cp = parseInt(dec, 10);
      if (Number.isNaN(cp) || cp < 0 || cp > 0x10ffff) return _;
      try {
        return String.fromCodePoint(cp);
      } catch {
        return _;
      }
    });
}

export function decodeHtmlEntities(value: string | null | undefined): string {
  if (!value) return '';
  let decoded = String(value);
  for (let i = 0; i < 6; i += 1) {
    const next = decodeNumericHtmlEntities(
      decoded
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#x27;/gi, "'")
        .replace(/&#39;/g, "'")
        .replace(/&apos;/gi, "'")
        .replace(/&#x2f;/gi, '/')
        .replace(/\u2019/g, "'") // right single quotation mark (smart apostrophe)
        .replace(/\u2018/g, "'"), // left single quotation mark
    );
    if (next === decoded) break;
    decoded = next;
  }
  return decoded;
}

/** Decode entities and trim - use for editable/display text from API. */
export function safeDisplayText(value: string | null | undefined): string {
  return decodeHtmlEntities(value).trim();
}
